// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__xxxA3","colBig":"styles_colBig__Q61eL","colSmall":"styles_colSmall__VN54l","shopifyNameWrapper":"styles_shopifyNameWrapper__19Qom"};